import styled from 'styled-components'
import { colors, screenSizes } from 'styles/theme'
import CheckBoxBG from 'public/assets/gallery/CheckBox.svg'
import { FlexRow } from 'styles/styled'

export const InfoTitle = styled.p`
  font-size: 16px;
  font-family: var(--font-dm-mono);
  font-weight: 500;
`

export const TopButtonsCont = styled(FlexRow)`
  justify-content: space-between;
  flex-wrap: wrap;

  @media (min-width: ${screenSizes.XS}px) {
    gap: 24px;
    justify-content: flex-end;
  }
`

export const MobileFilterWrap = styled(FlexRow)`
  gap: 16px;
  padding: 10 px 0;
  width: calc(100% + 40px);
  margin-left: -20px;
  margin: 0 auto;

  display: flex;
  justify-content: flex-end;

  @media (min-width: ${screenSizes.M}px) {
    display: none;
  }
`

export const StickyContainer = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;

  grid-template-areas:
    'header'
    'nfts';

  @media (min-width: ${screenSizes.M}px) {
    grid-template-columns: 304px 1fr;

    grid-template-areas:
      'header header'
      'nfts nfts';
  }
`

export const HeadingCont = styled.div<{ isSticky?: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-direction: column;
  gap: 8px;
  position: sticky;
  grid-area: header;
  top: 76px;
  z-index: 3;

  button {
    white-space: nowrap;
  }

  h1 {
    font-size: 24px;
    line-height: 60px;
    font-family: var(--font-tomorrow);
    font-weight: 600;
  }

  ${({ isSticky }) =>
    isSticky &&
    `
    h1{
      font-size: 24px;
    }
    width: calc(100% + 48px);
    margin-left: -24px;
    padding: 10px 24px;
    padding-top:0px;
    background: ${colors.secondary};
    
    `}

  @media (min-width: ${screenSizes.M}px) {
    flex-direction: row;
    align-items: center;
    padding-top: 16px;
    ${({ isSticky }) =>
      isSticky &&
      `
   
    width: calc(100% + 144px);
    padding: 14px 72px;
    margin-left: -72px;
    background: ${colors.secondary};
    
    `}
  }
`

export const SelectedFiltersCont = styled.div<{ isSticky?: boolean }>`
  width: 100%;
  position: sticky;
  top: 0px;
  z-index: 3;
  display: none;

  ${({ isSticky }) =>
    isSticky &&
    `
 background:${colors.secondary};
    `}

  @media  (min-width: ${screenSizes.M}px) {
    top: 164px;
    display: block;
  }
`

export const NftContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px;
  margin-top: 14px;
  align-items: flex-start;

  @media (min-width: ${screenSizes.XS}px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: ${screenSizes.M}px) {
    grid-template-columns: max-content 1fr;
  }

  grid-area: nfts;
`

export const CardsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding-top: 74px;

  h2 {
    font-size: 32px;
    font-family: var(--font-tomorrow);
  }

  @media (min-width: ${screenSizes.M}px) {
    width: 100%;
  }
`

export const FilterWrapper = styled.div<{ isFilterApplied?: boolean }>`
  width: 100%;
  border: 1px solid ${colors.borderColor};
  padding: 20px;
  display: none;
  flex-direction: column;
  gap: 24px;
  height: fit-content;
  background: ${colors.modalBackground};
  box-shadow: inset 0px -10px 5px 0px rgba(35, 147, 184, 0.1);
  position: sticky;
  top: 0;
  left: 0px;
  bottom: 0px;

  max-height: calc(100vh - 200px);
  overflow: hidden scroll;

  &::before {
    content: '';
    height: 20px;
    width: 20px;
    left: 0px;
    top: 0px;
    border-radius: 0px;
    position: absolute;
    border: 1px solid #2393b8;
    border-right: none;
    border-bottom: none;
  }

  &.mobile {
    display: flex;
  }

  @media (min-width: ${screenSizes.XS}px) {
    max-width: 304px;
    display: flex;
  }

  @media (min-width: ${screenSizes.M}px) {
    top: 164px;
  }

  /* Hide scrollbar for IE, Edge and Firefox */
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
`

export const FilterCont = styled.div`
  padding: 34px 0;
  border-top: 1px solid ${colors.borderColor};
`

export const FooterText = styled.div`
  text-align: center;
  display: flex;
  justify-content: center;
  width: 100%;
  color: rgba(255, 255, 255, 0.6);
  font-family: var(--font-tomorrow);
`

// ================== Mint-modal ==================

export const MintContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  .fiat {
    color: ${colors.primary};
  }

  input[type='checkbox'] {
    filter: invert(69%) sepia(9%) saturate(5244%) hue-rotate(160deg)
      brightness(73%) contrast(95%);
  }

  .right {
    transform: rotate(180deg);
  }

  a {
    font-family: var(--font-dm-mono);
    font-weight: 500;
    font-size: 12px;
    color: ${colors.primary};

    @media (min-width: ${screenSizes.XS}px) {
      font-size: 14px;
    }
  }

  label {
    cursor: pointer;
  }
`

export const Info = styled.p`
  font-family: var(--font-dm-mono);
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;

  @media (min-width: ${screenSizes.XS}px) {
    font-size: 14px;
  }
`

export const Value = styled(Info)`
  font-family: var(--font-tomorrow);
  font-weight: 400;
`

export const CheckBox = styled.div<{ checked: boolean }>`
  width: 18px;
  height: 18px;

  border-radius: 2px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: url(${CheckBoxBG?.src}) no-repeat center;
`
